export default "__VITE_ASSET__BmNeJIXB__"